import sammy from 'sammy.base';
import _ from 'underscore';

sammy.DefaultLocationProxy.prototype._startPolling = _.noop;
export default sammy;
